import TwoFactorAuthorization from './TwoFactorAuthorization';

export default TwoFactorAuthorization;
